<template>
  <div class="dataTables_wrapper" :style="wrapperStyle">
    <!-- Main table -->
    <tbl v-bind="tableProps" sm datatable>
      <tbl-head :color="headerColor" :textWhite="headerWhite">
        <tr>
          <th
            v-for="(column, i) in columns"
            :key="`column-header-${column.index}`"
            class="th-sm text-left"
          >
            {{ column.label }}
            <mdb-dropdown v-if="column.index !== null" multi-level>
              <mdb-dropdown-toggle class="ml-2 px-1 py-0" size="sm" slot="toggle" color="white">
                <mdb-icon icon="ellipsis-h" />
              </mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item
                  @click="sort(column.sortCallback, 'asc', i)"
                >Sort Ascending ▼</mdb-dropdown-item>
                <mdb-dropdown-item
                  @click="sort(column.sortCallback, 'desc', i)"
                >Sort Descending ▲</mdb-dropdown-item>
                <div class="dropdown-divider"></div>
                <mdb-dropdown-item
                  @click="$emit('hide-column', column.index)"
                >Hide</mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
            <mdb-icon
              v-if="recentSort.index === i"
              :icon="recentSort.sort === 'asc' ? 'sort-amount-down-alt' : 'sort-amount-up'"
            />
          </th>
        </tr>
      </tbl-head>
      <tbl-body>
        <tr v-for="(row, i) in filteredRows" :key="`row-${i}`" :tabindex="focus &&'1'" @focus="selectRow(i)" :class="focus && 'selectable-row'">
          <td v-for="(column, j) in columns" :key="`row-${i}-column-${j}`" class="calc-flights-table-cell">
            <component
              :is="column.componentName"
              :key="getUid()"
              :row="row"
            />
          </td>
        </tr>
        <tr v-if="!filteredRows.length">
          <td :colspan="columns.length">{{noFoundMessage}}</td>
        </tr>
      </tbl-body>
      <tbl-head v-if="tfoot" tag="tfoot">
        <tr>
          <th
            v-for="(column, i) in columns"
            :key="`column-footer-${i}`"
            class="th-sm sorting"
          >
            {{column.label}}
          </th>
        </tr>
      </tbl-head>
    </tbl>
    <!-- Main table -->
  </div>
</template>

<script>
import {
  mdbIcon,
  mdbInput,
  mdbTbl as Tbl,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbTblBody as TblBody,
  mdbTblHead as TblHead
} from 'mdbvue'
import { uid } from '../utils'
import CalcFlightsTableCellDirect from './CalcFlightsTableCellDirect'
import CalcFlightsTableCellRoute from './CalcFlightsTableCellRoute'
import CalcFlightsTableCellAirline from './CalcFlightsTableCellAirline'
import CalcFlightsTableCellDeparture from './CalcFlightsTableCellDeparture'
import CalcFlightsTableCellArrival from './CalcFlightsTableCellArrival'
import CalcFlightsTableCellWeekdays from './CalcFlightsTableCellWeekdays'
import CalcFlightsTableCellAirplane from './CalcFlightsTableCellAirplane'

export default {
  name: 'CalcFlightsTable',
  props: {
    data: {
      type: [Object, String],
      default: () => ({
        columns: [],
        rows: []
      })
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headerColor: {
      type: String
    },
    headerWhite: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String
    },
    minWidth: {
      type: String
    },
    maxHeight: {
      type: String
    },
    order: {
      type: Array
    },
    responsive: {
      type: Boolean,
      default: false
    },
    responsiveSm: {
      type: Boolean,
      default: false
    },
    responsiveMd: {
      type: Boolean,
      default: false
    },
    responsiveLg: {
      type: Boolean,
      default: false
    },
    responsiveXl: {
      type: Boolean,
      default: false
    },
    scrollY: {
      type: Boolean,
      defautl: false
    },
    searching: {
      type: Boolean,
      default: true
    },
    sorting: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    start: {
      type: String,
      default: 'Start'
    },
    end: {
      type: String,
      default: 'End'
    },
    next: {
      type: String,
      default: 'Next'
    },
    previous: {
      type: String,
      default: 'Previos'
    },
    arrows: {
      type: Boolean,
      default: false
    },
    display: {
      type: Number,
      default: 5
    },
    defaultRow: {
      type: String,
      default: '-'
    },
    defaultCol: {
      type: String,
      default: 'undefined'
    },
    tfoot: {
      type: Boolean,
      default: true
    },
    reactive: {
      type: Boolean,
      default: false
    },
    refresh: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 5000
    },
    search: {
      type: String,
      default: ''
    },
    noFoundMessage: {
      type: String,
      default: 'No matching records found'
    },
    showingText: {
      type: String,
      default: 'Showing'
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      updatedKey: null,
      reactiveFlag: false,
      recentSort: {
        callback: null,
        sort: null,
        index: null
      },
      interval: null,
      rows: this.data.rows || [],
      columns: this.data.columns || [],
      options: [10, 25, 50, 100],
      entries: 10,
      tableProps: {
        autoWidth: this.autoWidth,
        bordered: this.bordered,
        borderless: this.borderless,
        dark: this.dark,
        fixed: this.fixed,
        hover: this.hover,
        responsive: this.responsive,
        responsiveSm: this.responsiveSm,
        responsiveMd: this.responsiveMd,
        responsiveLg: this.responsiveLg,
        responsiveXl: this.responsiveXl,
        striped: this.striped,
        dtScrollY: this.scrollY,
        maxHeight: this.maxHeight
      },
      wrapperStyle: {
        maxWidth: this.maxWidth ? this.maxWidth : '100%',
        minWidth: this.minWidth ? this.minWidth : '100%',
        margin: '0 auto'
      }
    }
  },
  components: {
    Tbl,
    TblHead,
    TblBody,
    mdbInput,
    mdbIcon,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownItem,
    mdbDropdownMenu,

    CalcFlightsTableCellDirect,
    CalcFlightsTableCellRoute,
    CalcFlightsTableCellAirline,
    CalcFlightsTableCellDeparture,
    CalcFlightsTableCellArrival,
    CalcFlightsTableCellWeekdays,
    CalcFlightsTableCellAirplane
  },
  computed: {
    // filter objects by parameters match
    filteredRows () {
      return this.rows.filter(() => {
        return true
      })
    }
  },
  methods: {
    getUid () {
      return uid()
    },
    resort () {
      if (typeof this.recentSort.callback !== 'function') return
      if (typeof this.recentSort.sort !== 'string') return
      this.sort(this.recentSort.callback, this.recentSort.sort, this.recentSort.index)
    },
    sort (callback, sort, index) {
      this.recentSort = {callback, sort, index}
      const params = {
        selected: this.selected,
        selectedOptionalTypes: this.selectedOptionals,
        currency: this.currency
      }
      if (this.sorting) {
        if (typeof callback === 'string') {
          callback = x => x[callback]
        }
        sort === 'asc'
          ? this.rows.sort((a, b) => (callback(a, params) > callback(b, params) ? 1 : -1))
          : this.rows.sort((a, b) => (callback(a, params) > callback(b, params) ? -1 : 1))
        this.columns[this.columns.findIndex(column => column.sortCallback === callback)].sort = sort === 'asc' ? 'desc' : 'asc'
      }
    },
    filterArray () {
      if (this.filter) {
        this.rows.map(row => {
          if (this.filteredArray.indexOf(row[this.filter]) === -1) {
            this.filteredArray.push(row[this.filter])
          }
        })
        this.filteredArray.sort()
        this.filteredArray = this.filteredArray.filter((elem, index, self) => {
          return index === self.indexOf(elem)
        })

        const existingOptions = this.filterOptions.map(option => option.value)
        this.filteredArray.forEach(option => {
          if (existingOptions.indexOf(option) === -1) {
            this.filterOptions.push({value: option, text: option})
          }
        })
      }
    },
    selectRow (index) {
      this.$emit('selectRow', index)
    }
  },
  mounted () {
    // bind data or download form API
    if (typeof this.data === 'string') {
      this.fetchData()
    }
    // reactivness in data table
    if (this.reactive) {
      this.interval = setInterval(this.updateData, this.time)
    }

    // initial sorting
    if (this.order) {
      this.sort(this.columns[this.order[0]].field, this.order[1])
    }

    this.$emit('fields', this.columns)
  },
  watch: {
    data (newVal) {
      this.columns = newVal.columns
      this.rows = newVal.rows

      this.filterArray()
    }
  }
}
</script>

<style lang="sass" scoped>
.dropdown-toggle:after
  display: none

.selectable-row
  cursor: pointer
  transition: all 0.4s ease-out

.selectable-row:hover
  background-color: rgba(66, 133, 244, 0.1)

.selectable-row:focus
  outline: 1px solid #4285f4
  background-color: rgba(66, 133, 244, 0.1)

.calc-flights-table-cell
  word-break: break-word

.current-sort
  color: darkcyan
</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTable.vue